import React, { useState, useEffect } from 'react';
import { Row, Col, Collapse } from 'antd';
import { Link, useLocation,useNavigate } from 'react-router-dom';
import '../../../assets/css/patrocinadores.css';
import { CaretRightOutlined, LeftOutlined } from '@ant-design/icons';

import log_blanco from '../../../assets/images/sitio/03_Patrocinadores_sitio_IES/Ies_Zeraus.png';
import banner from '../../../assets/images/2022/stands/interiores/completos/stands_ind_zeraus.jpg';

import img_wsp_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_wsp from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_chatea_az.png';
import img_email_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_email from '../../../assets/images/2022/stands/interiores/BOTONES/ESP/btn_mas_info_az.png';
import img_wsp_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_wsp_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_-chat_az.png';
import img_email_en_hover from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';
import img_email_en from '../../../assets/images/2022/stands/interiores/BOTONES/ING/btn_moreinfo_az.png';

import btn_fb_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_fb from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_fb_Az.png';
import btn_tw from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_tw_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_twitter_Az.png';
import btn_yt from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_yt_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_youtube_az.png';
import btn_in from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_in_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_ig_az.png';
import btn_lk from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';
import btn_lk_hover from '../../../assets/images/2022/stands/interiores/ICONOS_redes/ic_linkedin_az.png';

import { Element } from 'react-scroll/modules';

const Zeraus = (props) => {
  const { Panel } = Collapse;
  const { idioma, onMetrica, nombre } = props;
  const [hover_imagen, setHoverImagen] = useState(0);
  const [hover_redes, setHoverRedes] = useState(0);
  //let navigate = useNavigate();

  return (
    <>
      <Row align='middle'>
        <Col span={24}>
          <br /><br /><br /><br />
        </Col>
        <Col xs={{ span: 4, offset: 1 }} md={{ span: 2, offset: 2 }}>
                  <p className="salir_patrocinador">
          <Link to="/#patrocinadores" className="salir_patrocinador"><LeftOutlined /> {idioma === 'es' ? 'Salir' : 'Get out'}</Link>
          </p>
        </Col>
        <Col xs={{ span: 8, offset: 1 }} md={{ span: 4, offset: 5 }}>
          {idioma==='es' ?
            <img src={log_blanco} style={{width:'100%'}} />
          :
          <img src={log_blanco} style={{width:'100%'}} />}
        </Col>
      </Row>
      <Row>
      <Col span={24} offset={0}>
        <a href="#video" onClick={()=>{onMetrica('video',nombre)}}>
          <img src={banner} style={{width:'100%'}} />
        </a>
        <br /><br />
        </Col>
        <Col span={20} offset={2}>
          {idioma === 'es' ?
          <p className="texto_patrocinadores">
            <span className='color_verde'><strong>SOBRE NOSOTROS</strong></span>
            <br />
          Somos una empresa 100% mexicana, número uno en desarrollo y fabricación de soluciones en iluminación en México. Nos encontramos en constante desarrollo para ofrecer las mejores opciones en iluminación y tendencias en el mercado actual. Nuestras luminarias cuentan con un diseño único e innovador, materiales y procesos de alta calidad.
          <br /><br />
          Visita nuestra página web: <a className="texto_patrocinadores_link" href="https://www.zeraus.com.mx/">www.zeraus.com.mx</a>
          <br /><br />
          Somos una marca registrada que nace en Abril del 2014, en Querétaro, Qro. corazón del territorio nacional. Conformada bajo la razón social: Iluminación Electrónica y Microprocesos S.A. de C.V.
          <br /><br />
          Nuestro fundador y Director general, Federico Suárez, se ha dedicado por más de 30 años al mercado de la iluminación en México y junto a todo el equipo Zeraus tiene una amplia experiencia en comercialización, producción e implementación de tecnologías de vanguardia LED para luminarias de interior y exterior. Además de tener alianzas comerciales en toda la república mexicana, nuestro mercado se está expandiendo continuamente al mercado latino e internacional.
          <br /><br />
          Nos especializamos en iluminación para grandes proyectos: corporativos, oficinas, interiores, retail, exteriores, arquitectónico, subacuáticos, industrial y alumbrado público. Visita nuestro catálogo <a className="texto_patrocinadores_link" href="https://www.zeraus.com.mx/source/catalogo/Zeraus_Catalogo_compress_14-09-20_compressed.pdf">aquí</a>.
        </p>
        :
        <p className="texto_patrocinadores">
          <span className='color_verde'><strong>ABOUT OUS</strong></span><br />
          We are a 100% Mexican company, number one in the development and manufacture of lighting solutions in Mexico. We are constantly developing to offer the best options in lighting and trends in the current market. Our luminaires have a unique and innovative design, high quality materials and processes.
          <br /><br />
          Visit our website: <a className="texto_patrocinadores_link" href="https://www.zeraus.com.mx/">www.zeraus.com.mx</a>
          <br /><br />
          We are a registered brand that was born in April 2014, in Querétaro, Qro. heart of the national territory. Formed under the company name: Lighting Electrónica y Microprocesos S.A. de C.V.
          <br /><br />
          Our founder and CEO, Federico Suárez, has been dedicated for more than 30 years to the lighting market in Mexico and together with the entire Zeraus team he has extensive experience in marketing, production and implementation of cutting-edge LED technologies for indoor lighting. and exterior. In addition to having commercial alliances throughout the Mexican Republic, our market is continually expanding to the Latin and international markets.
          <br /><br />
          We specialize in lighting for large projects: corporate, office, interior, retail, exterior, architectural, underwater, industrial and public lighting. Visit our catalog: <a className="texto_patrocinadores_link" href="https://www.zeraus.com.mx/source/catalogo/Zeraus_Catalogo_compress_14-09-20_compressed.pdf">here</a>.
        </p>}
        </Col>
        
        <Col span={16} offset={4} onClick={()=>onMetrica('video',nombre)}>
        <br />
        <div className="contenedor_video_patrocinador">
        <iframe className="video" src="https://www.youtube.com/embed/w5iOSjVnvVM?rel=0" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          
          <br /><br />
        </Col>
        <Element name="#video"/>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:8}} className="paddin_20">
          {idioma === 'es' ?
          <a onClick={()=>onMetrica('whatsapp',nombre)} target='_blank' href="https://api.whatsapp.com/send?phone=525559255265&text=Hola,%20me%20contacto%20desde%20el%20stand%20de%20Zeraus%20de%20la%20IES." onMouseEnter={()=>setHoverImagen(1)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 1 ? img_wsp_hover : img_wsp} style={{width:'100%'}} alt="video" /></a>
        :
        <a onClick={()=>onMetrica('whatsapp',nombre)} target='_blank' href="https://api.whatsapp.com/send?phone=525559255265&text=Hello,%20contact%20me%20from%20the%20Zeraus%20stand%20of%20the%20IES." onMouseEnter={()=>setHoverImagen(2)} onMouseLeave={()=>setHoverImagen(0)}><img src={hover_imagen === 2 ? img_wsp_en_hover : img_wsp_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
        <Col xs={{span:20, offset:2}} md={{span:8, offset:0}} className="paddin_20" style={{display:'none'}}>
        {idioma === 'es' ?
        <a onClick={()=>onMetrica('mail',nombre)} target='_blank' href=""><img src={img_email} style={{width:'100%'}} alt="video" /></a>
      :
      <a onClick={()=>onMetrica('mail',nombre)} target='_blank' href=""><img src={img_email_en} style={{width:'100%'}} alt="video" /></a>}
        </Col>
       </Row>
      <Row>
        <Col span={16} offset={4}>
          <br /><br />
        </Col>
        <Col span={20} offset={2}>
        {idioma === 'es' ?
          <p className="titulo_patrocinador_texto">PREGUNTAS FRECUENTES</p>
        :
        <p className="titulo_patrocinador_texto">FREQUENT QUESTIONS</p>
        }
        </Col>
        <Col span={20} offset={2}>
          <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} />}
            className="site-collapse-custom-collapse"
          >
            {idioma === 'es' ?
            <Panel header="¿Cuáles son nuestros productos?" key="1" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Manejamos una amplia variedad de luminarias para exteriores con opciones para empotrar o sobreponer, con diversas ópticas, temperaturas de color y cambios de color en RGB & RGBW.
                  </p>
                  <ul className="texto_patrocinadores">
                    <li>Regletas de suspender, empotrar o sobreponer para techo y arbotantes para muro</li>
                    <li>Proyectores para retail & residencias</li>
                    <li>Luminarias de empotrar o sobreponer para fuentes y ojos de agua</li>
                    <li>Luminarias para alumbrado público de alta potencia</li>
                    <li>Luminarias para el sector industrial: bodegas, almacenes, gasolineras & estacionamientos</li>
                  </ul>
                  <p className="texto_patrocinadores">
                  Visita nuestro catálogo <a target="_blank" className="texto_patrocinadores_link" href="https://www.zeraus.com.mx/source/catalogo/Zeraus_Catalogo_compress_14-09-20_compressed.pdf">aquí</a>.
                  </p>
            </Panel>
            :
            <Panel header="What are our products?" key="1" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            We handle a wide variety of outdoor luminaires with recessed or overlapping options, with different optics, color temperatures and color changes in RGB & RGBW.
            </p>
            <ul className="texto_patrocinadores">
              <li>Suspended, embeddable or superimposed strips for ceiling and flying buttresses for wall</li>
              <li>Projectors for retail & residences</li>
              <li>Recessed or superimposed luminaires for fountains and springs</li>
              <li>Luminaires for high power public lighting</li>
              <li>Luminaires for the industrial sector: warehouses, warehouses, gas stations & parking lots</li>
            </ul>
            <p className="texto_patrocinadores">
            Visit our catalog: <a target="_blank" className="texto_patrocinadores_link" href="https://www.zeraus.com.mx/source/catalogo/Zeraus_Catalogo_compress_14-09-20_compressed.pdf">aquí</a>.
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Dónde nos encontramos?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Nuestra planta central se encuentra en el estado de Querétaro, México. Tenemos oficinas en distintas partes de la república para brindarte una atención adecuada:
                  <br /><br />
                  Call center: 55 59 25 52 65
                  <br /><br />
                  Oficina Morelos: 777 218 9159
                  <br /><br />
                  Planta Querétaro  442  195 8321 / 8350
                  <br /><br />
                  Oficina Monterrey: 
                  <br />
                  Cel. 777 305 0168
                  <br />
                  Tel. 81 1306 6095 
                  <br /><br />
                  Oficina Puebla y sureste de México: 
                  <br />
                  Cel. 22 2653 7065
                  <br />
                  Tel. 22 2285 4077
                  <br /><br />
                  Oficina Guadalajara y pacífico de México:
                  <br />
                  Cel. 33 3170 7909 / 33 2349 8923
                  <br /><br />
                  Proyectos Gobierno: 
                  <br />
                  Cel. 442 467 8332
                  <br /><br />
                  Oficina Rivera Maya
                  <br />
                  Cel. 998 257 6831
                  </p>
            </Panel>
            :
            <Panel header="Where do we meet?" key="2" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Our central plant is located in the state of Querétaro, Mexico. We have offices in different parts of the republic to provide you with adequate attention:
                  <br /><br />
                  Call center: 55 59 25 52 65
                  <br /><br />
                  Oficina Morelos: 777 218 9159
                  <br /><br />
                  Planta Querétaro  442  195 8321 / 8350
                  <br /><br />
                  Oficina Monterrey: 
                  <br />
                  Cel. 777 305 0168
                  <br />
                  Tel. 81 1306 6095 
                  <br /><br />
                  Oficina Puebla y sureste de México: 
                  <br />
                  Cel. 22 2653 7065
                  <br />
                  Tel. 22 2285 4077
                  <br /><br />
                  Oficina Guadalajara y pacífico de México:
                  <br />
                  Cel. 33 3170 7909 / 33 2349 8923
                  <br /><br />
                  Proyectos Gobierno: 
                  <br />
                  Cel. 442 467 8332
                  <br /><br />
                  Oficina Rivera Maya
                  <br />
                  Cel. 998 257 6831
                  </p>
            </Panel>}
            {idioma === 'es' ? 
            <Panel header="¿Qué certificados de calidad manejamos?" key="3" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Todas nuestras luminarias cuentan con certificado NOM y certificado PAESE para alumbrado público.
                  </p>
            </Panel>
            :
            <Panel header="What quality certificates do we handle?" key="3" className="panel_patrocinador">
            <p className="texto_patrocinadores">
            All our luminaires are NOM certified and PAESE certified for public lighting.
            </p>
      </Panel>}
            {idioma === 'es' ?
            <Panel header="¿Qué garantías manejamos?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Cinco años de garantía en defectos de fabricación para todos nuestros productos.
                  </p>
            </Panel>
            :
            <Panel header="What guarantees do we handle?" key="4" className="panel_patrocinador">
                  <p className="texto_patrocinadores">
                  Five-year warranty on manufacturing defects for all our products.
                  </p>
            </Panel>}
          </Collapse>
        </Col>
        <Col span={20} offset={2}>
        <br /><br />
        {idioma === 'es' ?
        <p className="tituLogos">Obtener más información</p>
        :
        <p className="tituLogos">Get more information</p>}
        </Col>
        <Col xs={{span:10,offset:7}} md={{span:6,offset:9}}>
        
        <Row justify='center'>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('facebook',nombre)} href="https://www.facebook.com/zeraus.iluminacion" target="_blank" onMouseEnter={()=>setHoverRedes(1)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 1 ? btn_fb_hover : btn_fb} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={0} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('twitter',nombre)} href="" target="_blank" onMouseEnter={()=>setHoverRedes(2)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 2 ? btn_tw_hover : btn_tw} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores">
            <a onClick={()=>onMetrica('youtube',nombre)} href="https://www.youtube.com/watch?v=w5iOSjVnvVM" target="_blank" onMouseEnter={()=>setHoverRedes(3)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 3 ? btn_yt_hover : btn_yt} className="patrocinadores_redes_img" /></a>
          </Col>
          <Col span={6} className="contenedor_redes_patrocinadores contenedor_redes_patrocinadores_rigth">
            <a onClick={()=>onMetrica('instagram',nombre)} href="https://www.instagram.com/zerausmx/?hl=es-la" target="_blank" onMouseEnter={()=>setHoverRedes(4)} onMouseLeave={()=>setHoverRedes(0)}><img src={hover_redes === 4 ? btn_in_hover : btn_in} className="patrocinadores_redes_img" /></a>
          </Col>
        </Row>
        <br />
        </Col>
      </Row>
    </>
  )
}
export default Zeraus;